import Segment from '@/app/users/tracking/segment.js'
import axios from '@/utils/axios'
import { getAbsoluteBackendURL } from '@/utils/backend'
import isExperimentsEnabled from '@/services/experiment/utils/is-experiments-enabled.js'
import * as Sentry from '@sentry/vue'
import { shouldReportError } from '@/utils/error-monitoring/should-report-error'

/** @typedef {import('@/types/experiment.models').ExperimentResponse} ExperimentResponse */

/**
 * Builds the Experiment Id Service URL.
 * @param {string} experimentId -- Identifier for the experiment.
 * @return {string} URL to fetch the experiment variant.
 */
export function buildUrlExperiment(experimentId) {
  // removing empty spaces -- avoiding blank spaces as identifiers
  experimentId = experimentId.split(/\s+/).join('')

  if (!experimentId) {
    return false
  }
  const baseUrl = getAbsoluteBackendURL(import.meta.env.VUE_APP_EXPERIMENTS_SERVICE_BASE_URL)
  return `${baseUrl}/${experimentId}`
}

export default {
  /**
   * @param {string} experimentId - Identifier for the experiment.
   * @returns {string|null} - the experiment active returns variant_id as string, otherwise null.
   */
  async fetchExperimentVariant(experimentId) {
    if (isExperimentsEnabled() !== 'yes' || !experimentId) {
      return null
    }

    try {
      const url = buildUrlExperiment(experimentId)
      const response = await axios.get(url, {
        // `timeout` specifies the number of milliseconds before the request times out.
        // If the request takes longer than `timeout`, the request will be aborted.
        timeout: 3000,
      })
      if (response.data?.experiment?.variant_id) {
        Segment.track('Experiment - experiment active', {
          experiment_id: experimentId,
          variant_id: response.data.experiment?.variant_id,
        })
        return response.data?.experiment?.variant_id
      } else {
        return null
      }
    } catch (error) {
      if (shouldReportError(error)) {
        Sentry.captureException(error)
      }
      return null
    }
  },
}
